// =====================================================================================================================

export const NAMESPACE_GAME = 'game';

// =====================================================================================================================

export const MODEL_GAME_DEFINITION = 'GAME_DEFINITION';
export const MODEL_GAME = 'GAME';
export const MODEL_GAME_INSTANCE = 'GAME_INSTANCE';

// =====================================================================================================================

export const ADMINISTRATOR = 'ADMINISTRATOR';